import { Warning } from '@mui/icons-material'
import IIngestionStatus from 'app/interfaces/IIngestionStatus'
import ITemplateRow from 'app/pages/templateConfiguration/interfaces/ITemplateRow'

export const globalConstants = {
  homePath: '/',
}

export const templateStatus = {
  'Waiting for approval': {
    label: 'Waiting for Approval',
    color: '#f2a546',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  Approved: {
    label: 'Approved',
    color: '#669966',
    bg: 'rgba(80, 173, 93, 0.12)',
  },
  Rejected: {
    label: 'Rejected',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
}

export const fileStatus = {
  'In Progress': {
    label: 'In Progress',
    color: '#f2a546',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  Passed: {
    label: 'Passed',
    color: '#669966',
    bg: 'rgba(80, 173, 93, 0.12)',
  },
  Failed: {
    label: 'Failed',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  Warning: {
    label: 'Warning',
    color: '#669966',
    bg: 'rgba(80, 173, 93, 0.12)',
  },
  'Upload Failed': {
    label: 'Upload Failed',
    color: '#3C3C3C',
    bg: 'rgba(60, 60, 60, 0.12)',
  },
}

export const ingestionStatusChoice: IIngestionStatus = {
  Passed: {
    label: 'Passed',
    color: '#669966',
    bg: 'rgba(80, 173, 93, 0.12)',
  },
  'Trigger Aborted': {
    label: 'Trigger Aborted',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  'Trigger Failed': {
    label: 'Trigger Failed',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  Triggered: {
    label: 'Triggered',
    color: '#2196f3',
    bg: 'rgba(33, 150, 243, 0.12)',
  },
  Timeout: {
    label: 'Timeout',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  'In Progress': {
    label: 'In Progress',
    color: '#f2a546',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
  Failed: {
    label: 'Failed',
    color: '#d93155',
    bg: 'rgba(217, 49, 85, 0.12)',
  },
}

export const fileUploadeDetailsConstantOld = [
  { name: 'Total Files Uploaded', key: 'totalUploaded', color: undefined },
  { name: 'In Progress', key: 'inProgress', color: 'warning.main' },
  {
    name: 'Successfully Validated',
    key: 'successfullyValidated',
    color: 'success.main',
  },
  { name: 'Failures Encountered', key: 'failed', color: 'error' },
]

export const fileUploadeDetailsConstant = [
  { name: 'Total Files Uploaded', key: 'totalUploaded', color: undefined },
  { name: 'In Progress', key: 'inProgress', color: 'warning.main' },
  {
    name: 'Successfully Validated',
    key: 'successfullyValidated',
    color: 'success.main',
  },
  { name: 'Failures Encountered', key: 'failed', color: 'error.main' },
]

export const templateUploadeDetailsConstant = [
  { name: 'Total Templates Submitted', key: 'submitted', color: undefined },
  {
    name: 'Waiting for Approval',
    key: 'waitingForApproval',
    color: 'warning.main',
  },
  { name: 'Approved Templates', key: 'approved', color: 'success.main' },
  { name: 'Rejected Templates', key: 'rejected', color: 'error' },
]

export const newRow: ITemplateRow = {
  columnName: `New column`,
  columnId: '',
  insertAfterColumnId: null,
  dataType: 'int',
  templateId: 0,
  templateSubId: 0,
  description: '',
  piiApplicable: false,
  columnRules: [
    {
      ruleId: 4,
      templateColumnId: null,
      isActive: true,
      ruleName: 'Data Type',
      isNonMandatory: false,
    },
  ],
  nonMandatoryRules: [],
  columnCheck: [],
  dataComparison: [],
  isEditable: false,
  isIndex: false,
  isCurrentReportingYearPeriod: false,
  dateTimeFormat: null,
  dateTimeFormatId: null,
  dateTimeFormatRegex: null,
}

export const matomoDEVSiteID = 99

export const matomoPRODSiteID = 100
